import { Injectable } from '@angular/core';
import { createFrom, EventService } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { FbqGgOrderPlacedEvent } from './fbq-gg-order-placed-event';
import { CheckoutFacade, OrderPlacedEvent } from '../../../../spartacus/features/legacy-checkout/root';

@Injectable({
  providedIn: 'root',
})
export class FbqGgOrderPlacedEventBuilder {
  constructor(
    private eventService: EventService,
    private orderService: CheckoutFacade
  ) {
    const fbqGgOrderPlacedEventSource = this.eventService.get(OrderPlacedEvent).pipe(
      switchMap(() =>
        this.orderService.getOrderDetails().pipe(
          filter((order: Order | undefined): order is Order => !!order && !!order.entries),
          take(1),
          map((orderDetails) =>
            createFrom(FbqGgOrderPlacedEvent, {
              event: 'Purchase',
              parameters: {
                value: this.getTotalPriceFromOrder(orderDetails)?.value,
                currency: this.getTotalPriceFromOrder(orderDetails)?.currencyIso,
              },
            })
          )
        )
      )
    );

    eventService.register(FbqGgOrderPlacedEvent, fbqGgOrderPlacedEventSource);
  }

  getTotalPriceFromOrder(order: Order) {
    return order.totalPrice;
  }
}
